export const SET_FAQS = (state, payload) => {
	state.faqs = payload;
};
export const SET_FAQ_ITEM = (state, payload) => {
	state.faqItem = payload;
};
export const SET_ERROR = (state, payload) => {
	state.error = payload;
};
